module.exports = __webpack_public_path__ + "img/link-download-rb.7aaa1576.svg";